import {
    GROUP_LIST_REQUESTED,
    GROUP_LIST_RECEIVED,
    GROUP_LIST_ERROR
} from '../actions/groupList.js';
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
 * @return {RequestResult}
 */
export const groupList = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case GROUP_LIST_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), state.data);
        case GROUP_LIST_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.groupList, action.receivedAt);
        case GROUP_LIST_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
        default:
            return state
    }
};
